import { FC } from "react"
import { KTCard } from "../../../../../../_metronic/helpers"
import { DLMLabellingListProps, DLMLabellingListContextProvider, DLMLabellingListHeader } from "./components"

import { DLMLabellingTable } from "./table/DLMLabellingTable"

const DLMLabellingList:FC<DLMLabellingListProps> = ({sites, workflow, applicationOwnerId}) => {
  return (
  <DLMLabellingListContextProvider sites={sites} workflow={workflow} applicationOwnerId={applicationOwnerId}>
    <KTCard>
      <DLMLabellingListHeader  />
      <DLMLabellingTable />
    </KTCard>  
  </DLMLabellingListContextProvider>
  )
}

export { DLMLabellingList }